/* eslint-disable max-len */
import _ from 'lodash';

import { keyToValueAction, makeAction } from '../../utils';
import {
  MODEL_CUSTOM_VOCABULARY_SET_LIST,
  MODEL_CUSTOM_VOCABULARY_SET_RECORDS,
  MODEL_CUSTOM_VOCABULARY_ADD_RECORD,
  MODEL_CUSTOM_VOCABULARY_ADD_RECORDS,
  MODEL_CUSTOM_VOCABULARY_REMOVE_RECORDS,
  MODEL_CUSTOM_VOCABULARY_REMOVE_RECORD,
  MODEL_CUSTOM_VOCABULARY_IDENTITY,
} from './customVocabularyConstants';

const mutators = new Map();

export const providers = ((shortActions) => {
  const out = {};
  Object.keys(shortActions).forEach((actionName) => {
    out[`modelCustomVocabulary${_.upperFirst(actionName)}`] = shortActions[actionName];
  });
  return out;
})({
  // call from saga - do not call directly
  setList: keyToValueAction(mutators, MODEL_CUSTOM_VOCABULARY_SET_LIST, 'terminusListState'),
  removeRecord: makeAction(mutators, MODEL_CUSTOM_VOCABULARY_REMOVE_RECORD, (state, recordOrID) => {
    const modelCustomVocabularyById = { ...state.modelCustomVocabularyById };
    const id = typeof recordOrID === 'object' ? modelCustomVocabularyById[MODEL_CUSTOM_VOCABULARY_IDENTITY] : recordOrID;
    delete modelCustomVocabularyById[id];
    return { ...state, modelCustomVocabularyById };
    // @TODO: saga to sync byID to list
  }),
  removeRecords: makeAction(mutators, MODEL_CUSTOM_VOCABULARY_REMOVE_RECORDS, (state, records) => {
    const modelCustomVocabularyById = { ...state.modelCustomVocabularyById };
    records.forEach((recordOrID) => {
      const id = typeof recordOrID === 'object' ? modelCustomVocabularyById[MODEL_CUSTOM_VOCABULARY_IDENTITY] : recordOrID;
      delete modelCustomVocabularyById[id];
    });
    return { ...state, modelCustomVocabularyById };
    // @TODO: saga to sync byID to list
  }),
  addRecord: makeAction(mutators, MODEL_CUSTOM_VOCABULARY_ADD_RECORD, (state, record) => {
    const modelCustomVocabularyById = { ...state.modelCustomVocabularyById };
    modelCustomVocabularyById[record[MODEL_CUSTOM_VOCABULARY_IDENTITY]] = record;
    return { ...state, modelCustomVocabularyById };
    // @TODO: saga to sync byID to list
  }),
  addRecords: makeAction(mutators, MODEL_CUSTOM_VOCABULARY_ADD_RECORDS, (state, records) => {
    const modelCustomVocabularyById = { ...state.modelCustomVocabularyById };
    records.forEach((record) => {
      modelCustomVocabularyById[record[MODEL_CUSTOM_VOCABULARY_IDENTITY]] = record;
    });
    return { ...state, modelCustomVocabularyById };
    // @TODO: saga to sync byID to list
  }),
  setRecords: makeAction(mutators, MODEL_CUSTOM_VOCABULARY_SET_RECORDS, (state, records = []) => {
    const modelCustomVocabularyById = { };
    records.forEach((record) => {
      modelCustomVocabularyById[record[MODEL_CUSTOM_VOCABULARY_IDENTITY]] = record;
    });
    return { ...state, modelCustomVocabularyById };
    // @TODO: saga to sync byID to list
  }),
});

export const actions = Array.from(mutators.keys());

const initialValue = {
  modelCustomVocabularyById: {},
  // modelCustomVocabularyList: [],
};

export default function resolver(state = initialValue, { type, payload }) {
  if (!mutators.has(type)) {
    return state;
  }
  return mutators.get(type)(state, payload);
}
